import React from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';
import theme from 'theme/theme';

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0); 
  }
  40% {
    transform: scale(1); 
  } 
`;

const Dot = styled.div`
  z-index: 20;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  background-color: ${(props) => props.color};
  border-radius: 100%;
  display: inline-block;
  animation: ${css`${bounce}`} 1.6s ease-in-out 0s infinite both; 
  &:last-child {
    margin-right: 0;
  }
  animation-delay: ${(props) => props.animationDelay};
`;
Dot.propTypes = {
  animationDelay: PropTypes.string,
  color: PropTypes.string,
};
Dot.defaultProps = {
  animationDelay: '0',
  color: theme.colors.primary,
};

const Spinner = ({ color, ...otherProps }) => (
  <div {...otherProps}>
    <Dot color={color} animationDelay="-0.32s" />
    <Dot color={color} animationDelay="-0.16s" />
    <Dot color={color} />
  </div>
);
Spinner.propTypes = {
  color: PropTypes.string,
};
Spinner.defaultProps = {
  color: theme.colors.primary,
};

export default Spinner;
